import { format } from 'date-fns/fp';

const moneyFormatter = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' });
const percentFormatter = new Intl.NumberFormat('en', {
  style: 'percent',
  minimumFractionDigits: 2,
  minimumIntegerDigits: 1,
});
const basicNumberFormatter = new Intl.NumberFormat('en');

export const formatMoney = (value: number) => moneyFormatter.format(value);
export const formatPercent = (value: number) => percentFormatter.format(value);
export const formatNumber = (value: number) => basicNumberFormatter.format(value);

export const formatDate = format('MM-dd-yy');

export const formatDateWithTime = format('MMddyyhhmm');

export const formatLongDateString = (dateParam: string | undefined): string => {
  if (!dateParam) {
    return '';
  }
  const date = new Date(dateParam);
  const dateString = date.toLocaleDateString();
  const timeString = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
  return `${dateString} ${timeString}`;
};

const formatAsSimpleCosmosDate = format('yyyy-MM-dd');
const formatAsSimpleCosmosTime = format('HH:mm:ss.SSSSSSS');

export const formatAsCosmosDateString = (dateToFormat: Date) => {
  return `${formatAsSimpleCosmosDate(dateToFormat)}T${formatAsSimpleCosmosTime(dateToFormat)}Z`;
};
